<template>
  <div class="pt-5 pl-5 pb-10">
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-container fluid v-if="!loading">
      <v-row>
        <v-col>
          <v-card
            class="mx-auto grey lighten-3 text-center"
            max-width="100%"
            height="100%"
          >
            <div class="text-h4 pt-5">
              {{ status.bs1 || 0 }}
            </div>
            <div class="subtitle-2 pt-0 pa-5">{{ $t("bs1") }}</div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            class="mx-auto light-blue lighten-3 text-center"
            max-width="100%"
            height="100%"
          >
            <div class="text-h4 pt-5">
              {{ status.bs2 || 0 }}
            </div>
            <div class="subtitle-2 pt-0 pa-5">{{ $t("bs2") }}</div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            class="mx-auto red lighten-3 text-center"
            max-width="100%"
            height="100%"
          >
            <div class="text-h4 pt-5">
              {{ status.bs3 || 0 }}
            </div>
            <div class="subtitle-2 pt-0 pa-5">{{ $t("bs3") }}</div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            class="mx-auto orange lighten-3 text-center"
            max-width="100%"
            height="100%"
          >
            <div class="text-h4 pt-5">
              {{ status.bs4 || 0 }}
            </div>
            <div class="subtitle-2 pt-0 pa-5">{{ $t("bs4") }}</div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            class="mx-auto purple lighten-3 text-center"
            max-width="100%"
            height="100%"
          >
            <div class="text-h4 pt-5">
              {{ status.bs5 || 0 }}
            </div>
            <div class="subtitle-2 pt-0 pa-5">{{ $t("bs5") }}</div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            class="mx-auto light-green lighten-3 text-center"
            max-width="100%"
            height="100%"
          >
            <div class="text-h4 pt-5">
              {{ status.bs6 || 0 }}
            </div>
            <div class="subtitle-2 pt-0 pa-5">{{ $t("bs6") }}</div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            class="mx-auto brown lighten-3 text-center"
            max-width="100%"
            height="100%"
          >
            <div class="text-h4 pt-5">
              {{ status.bs7 || 0 }}
            </div>
            <div class="subtitle-2 pt-0 pa-5">{{ $t("bs7") }}</div>
          </v-card>
        </v-col>
      </v-row>
      <v-card color="mt-5">
        <v-data-table
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @page-count="pageCount = $event"
          :headers="headers"
          :items="list"
        >
          <template v-slot:[`item.check-in`]="{ item }">
            {{
              format(
                new Date(item.booking_details.dates[0] + "T00:00"),
                "MM/dd/yyyy"
              )
            }}
          </template>
          <template v-slot:[`item.check-out`]="{ item }">
            {{
              format(
                new Date(item.booking_details.dates[1] + "T00:00"),
                "MM/dd/yyyy"
              )
            }}
          </template>
          <template v-slot:[`item.booking_status`]="{ item }">
            {{ $t(item.booking_status) }}
          </template>
          <template v-slot:[`item._id`]="{ item }">
            <div class="text-center">
              <v-btn
                block
                small
                color="grey"
                :to="{
                  name: 'PartnerBookingViewComponent',
                  params: { id: item._id }
                }"
                dark
                >{{ $t("ViewAndEdit") }}
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <div class="text-right pt-5 pl-5 pr-5 grey lighten-4">
          <v-row>
            <v-col cols="12">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <WaitDialogComponent :waitDialog="waitDialog" />
    </v-container>
  </div>
</template>

<script>
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import timeoutMixin from "@/mixins/timeoutMixin.js";
import PartnerService from "@/services/PartnerService";
import { format } from "date-fns";

export default {
  name: "BookingsComponent",
  components: { WaitDialogComponent },
  mixins: [timeoutMixin],
  data() {
    return {
      format,
      loading: true,
      search: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      status: {},
      headers: [
        {
          text: this.$t("PropertyName"),
          class: "subtitle-2 grey lighten-2",
          sortable: false,
          value: "property_id.name"
        },
        {
          text: this.$t("CheckIn"),
          class: "subtitle-2 grey lighten-2",
          sortable: false,
          value: "check-in"
        },
        {
          text: this.$t("CheckOut"),
          class: "subtitle-2 grey lighten-2",
          sortable: false,
          value: "check-out"
        },
        {
          text: this.$t("TripStatus"),
          class: "subtitle-2 grey lighten-2",
          sortable: false,
          value: "booking_status"
        },
        {
          text: this.$t("Actions"),
          class: "subtitle-2 grey lighten-2 text-center",
          value: "_id",
          sortable: false,
          align: "center"
        }
      ],
      waitDialog: false,
      list: [],
      error: null,
      valid: null,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  created: function() {
    if (this.$store.state.user.role != "Host") {
      this.$router.push({ name: "Dashboard" });
    }
    PartnerService.bookings({})
      .then(result => {
        this.loading = false;
        this.list = result.data.list;
        this.status.bs1 = result.data.bs1;
        this.status.bs2 = result.data.bs2;
        this.status.bs3 = result.data.bs3;
        this.status.bs4 = result.data.bs4;
        this.status.bs5 = result.data.bs5;
        this.status.bs6 = result.data.bs6;
        this.status.bs7 = result.data.bs7;
      })
      .catch(err => {
        this.error = err.response.data.error;
        this.loading = false;
      });
  },
  methods: {}
};
</script>

<style></style>
